module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admission/payment-details/payment-details.component.scss
// module id = ./src/app/admission/payment-details/payment-details.component.scss
// module chunks = main